import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MunilyPaginationButtonsAlign, MunilyPaginationButtonsSize } from './pagination-buttons.types';

@Component({
  selector: 'common-pagination-buttons',
  templateUrl: './pagination-buttons.component.html',
  styleUrls: ['./pagination-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'common-pagination-buttons-host',
  },
})
export class PaginationButtonsComponent {
  @Input() length = 0;
  @Input() pageIndex = 0;
  @Input() pageSize = 10;
  @Input() showFirstLastButtons = true;
  @Input() disabled = false;
  @Input() ariaLabel = '';
  @Input() size: MunilyPaginationButtonsSize = 'large';
  @Input() align: MunilyPaginationButtonsAlign = 'start';

  @HostBinding('class.common-pagination-buttons-host--align-center')
  get alignCenterClass(): boolean {
    return this.align === 'center';
  }

  @Output() page = new EventEmitter<PageEvent>();

  onPage(ev: PageEvent): void {
    this.page.emit(ev);
  }
}
